(function ($){
    // Function to enable the update cart button after a delay
    function update_cart_activation(){
        setTimeout(function (){
            $("[name='update_cart']").prop('disabled', false).attr('aria-disabled', 'false');
        }, 500);
    }

    // Function to trigger the update cart button click event
    function run_update_cart(){
        $("[name='update_cart']").trigger('click');
    }

    // Event listener for updated cart totals to enable the update cart button
    $('body').on('updated_cart_totals', function() {
        update_cart_activation();
    });

    // Initial call to enable the update cart button after 1 second
    setTimeout(function (){
        update_cart_activation();
    },1000);

    function moveNoticesToCustomContainer() {
        // Clear existing notices in our custom container
        $('#coupon-notice-wrapper').empty();
        
        // Find notices anywhere in the DOM
        $('.woocommerce-error, .woocommerce-message, .woocommerce-info').each(function() {
            // Clone the notice and append to our custom container
            $(this).clone().appendTo('#coupon-notice-wrapper');
            
            // Hide the original notice to prevent duplication
            $(this).hide();
        });
        
        // Scroll to the notice if needed
        if ($('#coupon-notice-wrapper').children().length > 0) {
            $('html, body').animate({
                scrollTop: $('#coupon-notice-wrapper').offset().top - 100
            }, 300);
        }
    }

    // Direct AJAX handling for coupon submission
    $('#cart-coupon').on('click', function(e){
        e.preventDefault();
        
        var couponCode = $('#coupon_code_duplication').val();
        $('#coupon_code').val(couponCode);
        
        // If empty coupon field, show error manually
        if (!couponCode || couponCode === '') {
            $('#coupon-notice-wrapper').html('<ul class="woocommerce-error" role="alert"><li>Please enter a coupon code.</li></ul>');
            return;
        }
        
        // Show loading state
        $('#coupon-notice-wrapper').html('<p class="loading-coupon">Applying coupon...</p>');
        
        // Trigger the hidden apply coupon button
        $('#cart-apply-coupon').trigger('click');
        
        // Listen for all AJAX requests that happen after clicking the button
        $(document).ajaxComplete(function handler(event, xhr, settings) {
            console.log('AJAX completed', settings.url);
            
            // Only process coupon-related AJAX requests
            if (settings.url.indexOf('apply_coupon') !== -1 || 
                settings.url.indexOf('remove_coupon') !== -1) {
                
                console.log('Coupon AJAX detected');
                
                // Check the response text for woocommerce-error
                if (xhr.responseText && xhr.responseText.indexOf('woocommerce-error') > -1) {
                    // Hide any existing notices first
                    $('.woocommerce-notices-wrapper .woocommerce-error, .woocommerce-notices-wrapper .woocommerce-message, .woocommerce-notices-wrapper .woocommerce-info').hide();
                    
                    // Directly insert the error message from the response
                    $('#coupon-notice-wrapper').html(xhr.responseText);
                } else {
                    // Otherwise move any notices that might have been added to the page
                    moveNoticesToCustomContainer();
                }
                
                // Remove this handler to avoid multiple bindings
                $(document).off('ajaxComplete', handler);
            }
        });
    });

    // Initial check for any notices that might already be present
    $(document).ready(function() {
        moveNoticesToCustomContainer();
    });
}(jQuery));